<template>
  <div class="form-group" :class="{ 'has-danger': error }">
    <select class="form-control"
      :id="'input-text-' + this._uid"
      ref="input"
      :value="value"
      v-on:input="updateValue($event.target.value)"
      :disabled="disabled || !canEdit">
      <option :value="placeholder" disabled selected v-if="placeholder">
        {{ placeholder }}
      </option>
      <option v-for="option in options" :key="option.value" v-bind:value="option.value">
        {{ option.text }}
      </option>
    </select>
    <under-label :id="'input-text-' + this._uid"><slot></slot> <span v-if="required" class="required" data-toggle="tooltip" data-placement="bottom" title="Required">*</span></under-label>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import UnderLabel from "./_UnderLabel.vue";

export default {
  name: "shared-under-select",
  components: {
    UnderLabel
  },
  props: [
    "value",
    "options",
    "error",
    "required",
    "type",
    "disabled",
    "maxlength",
    "min",
    "max",
    "placeholder",
    "returnArray",
    "hideLabel",
    "disableAutoSave"
  ],
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  watch: {
    value() {
      if (!this.disableAutoSave) {
        this.autoSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.form-control {
  background-color: transparent;
  border-radius: 0 !important;
  border: solid 0px $gray-800;
  border-bottom: solid 1px $gray-400;
  box-shadow: 0 0 0;
  font-size: 1.25em;
  font-weight: bold;
  height: 1.4em !important;
  margin: 0;
  padding: 0.5rem;
  padding-left: 0;
  padding-top: 0;
  padding-bottom: 0;
  text-align: inherit;
  outline: none;
  &:disabled {
    color: rgb(127, 127, 127);
  }
  &:focus {
    outline: none;
    background-color: $gray-200;
  }
  &:hover:not(:disabled) {
    background-color: $gray-200;
  }
  -webkit-appearance: none;
  -webkit-border-radius: 0px;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>");
  background-size: 9px 6px;
  background-position: right -1rem center;
  background-origin: content-box;
  background-repeat: no-repeat;
  padding-right: 1.5rem;
}
</style>
